<template>
  <div class="daily-bonus-wrapper">
    <v-btn
      v-if="_availableBonus"
      :class="{
        'right-drawer-prevent':
          $vuetify.breakpoint.lgAndUp && $route.name === 'Home',
      }"
      class="btn bonus-btn gradient-green glow mt-14 mt-sm-12 mt-sm-16"
      :height="$vuetify.breakpoint.smAndUp ? '4rem' : '3.25rem'"
      right
      fixed
      absolute
      top
      @click="open()"
    >
      <v-img
        :src="require('@/assets/main/wheel.png')"
        class="ml-n1 rotate"
        contain
        :width="$vuetify.breakpoint.smAndUp ? '2.625rem' : '2rem'"
      />

      <span class="text-h6 text-sm-h5 font-weight-bold ml-2">
        <div
          class="text-left bonus-text white--text bebas-neue green--text text--darken-3"
        >
          BÔNUS<br />DISPONÍVEL
        </div>
      </span>

      <v-sheet class="bonus-badge px-1" color="red">
        <span class="white--text text-caption text-md-body-2 font-weight-bold">
          Grátis
        </span>
      </v-sheet>
    </v-btn>

    <v-dialog v-if="!result" v-model="dialog" width="37.5rem" persistent>
      <template v-if="dialog">
        <div
          v-if="!result"
          class="d-flex flex-column justify-center align-center fill-height"
        >
          <div v-if="!loading.wheel" class="d-flex justify-end fill-width">
            <v-btn :disabled="loading.spin" color="white" text @click="close()">
              Fechar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </div>

          <loader v-if="loading.wheel" />

          <PrizeWheel
            v-else
            :loading="loading.spin"
            :prizes="prizes"
            @started="handleStarted"
            @finished="handleFinished($event)"
          />

          <div v-if="showTimer" class="timer-wrapper">
            <span class="text-h1 font-weight-black russo-one">
              {{ countdown > 0 ? countdown : "Já" }}
            </span>
          </div>
        </div>
      </template>
    </v-dialog>

    <v-dialog v-else v-model="resultDialog" fullscreen persistent>
      <RotatoryBackground
        :color="result?.winner ? 'hit' : 'fail'"
        :confetti="result?.winner"
      >
        <div
          class="d-flex flex-column align-center justify-center pt-12 mb-12 px-2"
          :class="{ 'fill-height': !lastWinners.length }"
        >
          <v-card
            class="card rounded-xl mb-2"
            :width="$vuetify.breakpoint.smAndUp ? '30rem' : '100%'"
            color="neutral1"
          >
            <div class="d-flex align-center justify-center mb-4">
              <v-icon :color="result?.winner ? 'amber' : 'red'" size="5rem">
                {{ result?.winner ? "far fa-grin-stars" : "far fa-frown" }}
              </v-icon>
            </div>

            <div
              class="text-center text-h5 font-weight-bold primary--text mb-2"
            >
              <span v-if="result?.winner">
                Parabéns! Você ganhou
                <span class="font-weight-bold">{{ result?.name }}</span
                >!
              </span>

              <span v-else>Que pena, tente amanhã novamente!</span>
            </div>

            <div class="text-center text-body-1 mb-4">
              <div v-if="result?.winner">
                <div v-if="prizeWon === 'item'" class="my-4">
                  <div v-if="loading.use">
                    Carregando seus números, aguarde!
                  </div>

                  <div v-else>
                    <div class="text-body-1 text-center mb-3">
                      Parabéns! 🎉 Seus bilhetes foram aplicados ao sorteio
                      atual, abaixo estão seus números. Boa sorte! 🍀
                    </div>

                    <v-card
                      v-if="luckyTokens.length"
                      class="card pa-4 mb-3"
                      color="neutral2"
                      outlined
                    >
                      <div class="text-center text-body-1">
                        Você encontrou {{ luckyTokens.length }}
                        <span class="font-weight-bold primary--text"
                          >cotas premiadas</span
                        >, o valor de
                        <span class="font-weight-bold primary--text">
                          R$
                          {{
                            currencyMask(
                              luckyTokens.reduce(
                                (sum, item) => sum + (item.awards?.cash || 0),
                                0
                              )
                            )
                          }}
                        </span>
                        foi creditado a sua carteira!
                      </div>
                    </v-card>

                    <div class="text-body-2 text-center mb-2">
                      {{ tokensCount > 1 ? "Seus números" : "Seu número" }}
                    </div>

                    <template v-if="tokens.length">
                      <v-card
                        v-if="tokensCount <= 1"
                        class="card py-1 align-self-center mb-4"
                        color="neutral2"
                        :class="{
                          'lucky-ticket': luckyTokens.find(
                            (el) => el.token === tokens[0]
                          ),
                        }"
                      >
                        <div class="text-h4 font-weight-black token">
                          {{ tokens[0] }}
                        </div>
                      </v-card>

                      <v-slide-group v-else class="mb-4" show-arrows>
                        <v-slide-item v-for="(item, i) in tokens" :key="i">
                          <v-card
                            class="card py-1 align-self-center mr-2"
                            color="neutral2"
                            :class="{
                              'lucky-ticket': luckyTokens.find(
                                (el) => el.token === item
                              ),
                            }"
                          >
                            <div class="text-h6 font-weight-black token">
                              {{ item }}
                            </div>
                          </v-card>
                        </v-slide-item>

                        <v-slide-item v-if="tokensCount > 10">
                          <v-card
                            class="card py-1 align-self-center mr-2"
                            color="primary"
                            height="100%"
                            :to="{
                              name: 'Result',
                              params: { id: _currentRaffle?._id },
                            }"
                            @click="close()"
                          >
                            <div
                              class="d-flex fill-height align-center justify-center neutral--text"
                            >
                              Ver mais
                            </div>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </template>

                    <div class="mt-6 d-flex align-center justify-center">
                      <v-btn
                        class="btn"
                        color="primary"
                        :to="{
                          name: 'Result',
                          params: { id: _currentRaffle?._id },
                        }"
                        rounded
                        @click="close()"
                      >
                        <span> Ver todos os meus números </span>

                        <v-icon right> fas fa-chevron-right </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>

                <div>
                  Aproveite seu <span class="font-weight-bold">prêmio</span> e
                  continue jogando para ganhar mais. Boa sorte em sua próxima
                  rodada!
                </div>
              </div>

              <div v-else>
                Infelizmente, você não ganhou
                <span class="font-weight-bold">nada</span> desta vez. Continue
                girando para ter mais chances de ganhar. Boa sorte na próxima
                tentativa!
              </div>
            </div>

            <ShareBtn
              :title="
                result?.winner
                  ? `🎉 Ganhei na roleta! Olha isso: ${result?.name} 🏆`
                  : `🎰 Tentei a roleta… mas não foi dessa vez 😞`
              "
              :description="
                result?.winner
                  ? `💬 Joguei de graça e fui premiado! Agora é sua vez! 🎰✨. 👉 Rode a roleta e descubra seu prêmio!`
                  : '💬 Vai que a sorte tá com você? 🍀. Rode grátis agora e veja o que te espera! 🎁🎯'
              "
            />

            <v-btn
              class="btn mt-4"
              color="primary"
              rounded
              block
              @click="close()"
            >
              <v-icon left small>fas fa-arrow-left</v-icon>
              Voltar para o início
            </v-btn>
          </v-card>

          <v-card
            v-if="lastWinners.length"
            class="card rounded-xl"
            color="neutral1"
            :width="$vuetify.breakpoint.smAndUp ? '30rem' : '100%'"
          >
            <div class="text-h6 mb-2">Últimos ganhadores!!!</div>

            <v-list class="transparent pa-0 mb-4" nav dense>
              <v-list-item
                v-for="(item, i) in lastWinners"
                class="neutral2 rounded-lg"
                :key="i"
              >
                <v-list-item-action class="my-0 mr-4">
                  <v-avatar class="border-primary" color="neutral4" size="2rem">
                    <v-img v-if="item.person.photo" :src="item.person.photo" />

                    <v-icon v-else small>far fa-user</v-icon>
                  </v-avatar>
                </v-list-item-action>

                <v-list-item-title>
                  {{ item.person.name }}
                </v-list-item-title>

                <v-list-item-title class="text-right accent--text">
                  <div v-if="item.reward === 'event'">
                    <div v-if="item.eventType === 'free_spin'">
                      Rodada grátis
                    </div>
                    <div v-if="item.eventType === 'nothing'">Sem premiação</div>
                  </div>

                  <div v-if="item.reward === 'money'">
                    R$ {{ currencyMask(item.amount || 0) }}
                  </div>

                  <div v-if="item.reward === 'item'">
                    {{ item.item.name }}
                  </div>

                  <div v-if="item.reward === 'nothing'">Sem premiação</div>
                </v-list-item-title>
              </v-list-item>
            </v-list>

            <v-btn class="btn" color="primary" rounded block @click="close()">
              <v-icon left small>fas fa-arrow-left</v-icon>
              Voltar para o início
            </v-btn>
          </v-card>

          <loader-overlay v-model="loading.use" />
        </div>
      </RotatoryBackground>
    </v-dialog>

    <BonusCall ref="bonusCall" @submit="open()" @cancel="cancelBonusCall()" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  getWheels,
  canWheelSpin,
  spinWheel,
  getHistoryWheel,
} from "@/services/wheels";
import { useItem } from "@/services/items";
import { currencyMask } from "@/helpers";
import PrizeWheel from "@/components/prizeWheel/PrizeWheel.vue";
import RotatoryBackground from "@/components/rotatoryBackground/RotatoryBackground";
import ShareBtn from "@/components/shareBtn/ShareBtn";
import BonusCall from "./partials/bonusCall/BonusCall";

export default {
  name: "DailyBonus",

  components: {
    PrizeWheel,
    RotatoryBackground,
    ShareBtn,
    BonusCall,
  },

  data() {
    return {
      buttonOpacity: 1,
      scrollThreshold: 25,
      allowedTimer: false,
      loading: {
        wheel: true,
        spin: false,
        use: false,
      },
      obtained: false,
      dialog: false,
      resultDialog: false,
      result: null,
      showTimer: false,
      countdown: 3,
      wheelID: "",
      prizes: [],
      prizeWon: "",
      tokens: [],
      luckyTokens: [],
      tokensCount: 0,
      request: null,
      itemID: "",
      qty: 0,
      lastWinners: [],
      bonusCall: false,
      bonusSound: null,
    };
  },

  beforeMount() {
    this.getWheels();
    this.bonusSound = new Audio(require("@/assets/sounds/bonus.mp3"));
  },

  watch: {
    _currentRaffle: {
      handler(val) {
        if (val) {
          this.canWheelSpin();
        }
      },
      deep: true,
      immediate: true,
    },

    _availableBonus(val) {
      if (val && !this.dialog) {
        this.triggerBonusSound();
        this.open();
      }
    },
  },

  computed: {
    ...mapGetters({
      _user: "user",
      _currentRaffle: "currentRaffle",
      _bonusState: "bonusState",
    }),

    _availableBonus() {
      return !this._bonusState.earned && this._bonusState.eligible;
    },
  },

  methods: {
    ...mapActions(["setBonusEligible", "setBonusEarned"]),

    async getWheels() {
      try {
        const { data } = await getWheels();

        this.wheelID = data.wheel?._id;
        this.prizes = data.wheel.items.map((el, index) => {
          return { ...el, id: index + 1, value: el.reward };
        });

        await this.canWheelSpin();
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.wheel = false;
      }
    },

    async canWheelSpin() {
      if (this.obtained || !this.wheelID || !this._currentRaffle) return;

      try {
        const payload = {
          personID: this._user._id,
          raffleID: this._currentRaffle?._id,
        };

        const { data } = await canWheelSpin(this.wheelID, payload);

        this.obtained = true;
        this.setBonusEarned(!data.canSpin);
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async handleStarted(resolve, reject) {
      if (this.loading.spin) return;

      try {
        this.loading.spin = true;

        const { data } = await spinWheel(this.wheelID);

        // this.getHistoryWheel();

        const prize = this.prizes.find((el) => el.name === data.name);

        if (this.allowedTimer) await this.handleTimer();

        resolve(prize.id);
      } catch (error) {
        this.$alert(error?.message, "error");
        reject(error);
      } finally {
        this.loading.spin = false;
      }
    },

    async handleTimer() {
      this.showTimer = true;

      this.countdown = 3;

      const timerPromise = new Promise((timerResolve) => {
        const interval = setInterval(() => {
          this.countdown--;

          if (this.countdown < 0) {
            clearInterval(interval);
            this.showTimer = false;
            timerResolve();
          }
        }, 1000);
      });

      return await timerPromise();
    },

    async useItem(itemID, qty) {
      try {
        this.loading.use = true;

        this.itemID = itemID;
        this.qty = qty;

        const payload = {
          target: "raffles",
          targetID: this._currentRaffle?._id,
          qty: qty,
        };

        const { data } = await useItem(itemID, payload);

        this.tokens = data.tokens;
        this.luckyTokens = data.luckyTokens;
        this.tokensCount = data.tokensCount;

        this.$root.$emit("load-session");
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.use = false;
      }
    },

    async handleFinished(event) {
      // this.getHistoryWheel();
      this.prizeWon = event?.reward || "";

      if (event?.eventType === "free_spin") {
        return this.$alert("Gire a roleta novamente", "info");
      }

      if (event?.reward === "item" && event?.item?._id) {
        this.useItem(event.item?._id, event.amount);
      }

      this.$root.$emit("load-session");

      setTimeout(() => {
        this.result = {
          ...event,
          winner: event?.eventType !== "nothing",
        };

        this.resultDialog = true;
        this.setBonusEarned(true);
      }, 1000);
    },

    async getHistoryWheel() {
      try {
        const payload = {
          offset: 0,
          limit: 10,
          sortBy: "createdAt",
          sortOrder: "desc",
          rewards: ["money", "item", "tickets"],
        };

        const { data } = await getHistoryWheel(payload);
        this.lastWinners = data;
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    open() {
      this.resetData();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.resetData();
    },

    resetData() {
      this.resultDialog = false;
      this.result = null;
      this.showTimer = false;
      this.countdown = 3;
    },

    handleBonusCall() {
      this.$refs.bonusCall.open();
      this.bonusCall = true;
    },

    cancelBonusCall() {
      this.bonusCall = false;
    },

    triggerBonusSound() {
      if (!this.bonusSound)
        this.bonusSound = new Audio(require("@/assets/sounds/bonus.mp3"));

      this.bonusSound.volume = 0;

      this.bonusSound
        .play()
        .then(() => {
          this.bonusSound.volume = 1;
        })
        .catch(() => {
          /* ignore */
        });
    },

    currencyMask,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
